// src/components/News.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import useReveal from '../hooks/useReveal';
import Modal from './Modal';

const INITIAL_VISIBLE = 3;

// タイ仏暦の日付フォーマット
const THAI_MONTHS = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
  'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม',
  'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
];

const formatDate = (timestamp) => {
  if (!timestamp?.toDate) return '';
  const date = timestamp.toDate();
  return `${date.getDate()} ${THAI_MONTHS[date.getMonth()]} ${date.getFullYear() + 543}`;
};

function News() {
  const sectionRef = useReveal();
  const [news, setNews] = useState([]);
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const q = query(collection(db, 'announcements'), orderBy('date', 'desc'));
        const querySnapshot = await getDocs(q);
        const newsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNews(newsList);
      } catch (error) {
        console.error('Firestoreからのデータ取得エラー: ', error);
      }
    };

    fetchNews();
  }, []);

  if (news.length === 0) {
    return null;
  }

  return (
    <section id="news" className="reveal" ref={sectionRef}>
      <div className="section-content">
        <span className="section-eyebrow">News</span>
        <h2 className="section-title">ประกาศ</h2>
        <ul className="news-list">
          {news.slice(0, visibleCount).map((newsItem) => (
            <li key={newsItem.id} className="news-item">
              <button type="button" onClick={() => setSelectedNews(newsItem)}>
                <span className="news-date">{formatDate(newsItem.date)}</span>
                <span className="news-title">{newsItem.title}</span>
                <span className="material-icons news-arrow" aria-hidden="true">
                  chevron_right
                </span>
              </button>
            </li>
          ))}
        </ul>
        {visibleCount < news.length && (
          <div className="more-button-container">
            <button
              type="button"
              onClick={() => setVisibleCount((count) => count + INITIAL_VISIBLE)}
              className="more-button"
            >
              ดูเพิ่มเติม
            </button>
          </div>
        )}
      </div>

      {selectedNews && (
        <Modal onClose={() => setSelectedNews(null)} label={selectedNews.title}>
          <h2>{selectedNews.title}</h2>
          <h4>{formatDate(selectedNews.date)}</h4>
          {selectedNews.imageURL && (
            <img src={selectedNews.imageURL} alt={selectedNews.title} />
          )}
          <p>{selectedNews.body}</p>
          {selectedNews.link && (
            <a href={selectedNews.link} target="_blank" rel="noopener noreferrer">
              ดูรายละเอียด
            </a>
          )}
        </Modal>
      )}
    </section>
  );
}

export default News;
